export type KeyboardLayoutMap = ReadonlyMap<string, string>;

const SINGLE_LETTER = /^[a-z]$/;

/**
 * Resolve the glyph printed on a physical key for display. Falls back when the
 * layout map is unavailable or has no entry for the code.
 */
export const layoutDisplayLabel = (
  code: string,
  layoutMap: KeyboardLayoutMap | null,
  fallback: string
): string => {
  if (!layoutMap) return fallback;
  const label = layoutMap.get(code);
  if (!label) return fallback;
  if (SINGLE_LETTER.test(label)) return label.toUpperCase();
  return label;
};
